export default {
  invalid_email_message: 'Please enter a valid email address.',
  first_name_required: 'First name is required',
  last_name_required: 'Last name is required',
};
